import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { getLastLogin, XMLrequest } from "../Url";
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SignInEditor from "./signInTools/SignInEditor";
import { getEditorListFormat } from "../MainPage/Tools/Tools";

const SelectUser = (props: any) => {
  let LastUser = getLastLogin().split(",");
  const [users, setUserList] = useState([]);

  const getUser = () => {
    if (props.drxInfo !== "") {
      let params = new Map();
      params.set("comand", "getuserlist");
      params.set("ConfigName", encodeURIComponent(props.drxInfo));
      setUserList(XMLrequest(params));
    }
  };

  const OnKeyEnter = (e: any) => {
    if (e.keyCode === 13) {
      props.KeyDown(e);
    } else if (e.keyCode === 40) {
      getUser();
    }
  };

  function MenuItems(userList: any) {
    return getEditorListFormat(Object.values(userList));
  }

  return (
    <Grid item xs id="userGrid">
      <SignInEditor
        autocomplete="username"
        label="Имя пользователя"
        onKeyDown={OnKeyEnter}
        onPickListButtonClick={getUser}
        items={MenuItems(users)}
        onEdit={props.setBackInfo}
        endButtons={
          <>
            {props.HasOrgs === "1" ? (
              <IconButton onClick={props.selectOrg}>
                <MoreHorizIcon />
              </IconButton>
            ) : null}
          </>
        }
        defaultValue={{ label: LastUser === undefined ? "" : LastUser[1] }}
      />
    </Grid>
  );
};

export default SelectUser;
